import React from "react";

import { ILongProps } from "components/dashboard/product-template-table/utils/interfaces";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";

export default function Long({
  value,
  unit,
  selectionValues,
  formatNumber = true,
  changeHandler,
  isInEditMode,
}: ILongProps) {

  const onSelect = (e: DropdownChangeEvent) => {
      const val = parseInt(e.value, 10);
      if (Number.isNaN(val)) {
        easasAlert({ summary: T("alert.error"), detail: T("alert.selected-is-nan"), severity: "error" });
        return;
      }
      changeHandler(parseInt(e.value, 10));
  };

  const handleChangeValue = (val: number | null) => {
    if (val !== null && val !== undefined) {
      changeHandler(val);
    }
  };

  if (isInEditMode) {
    if (selectionValues && selectionValues.length > 0) {
      return (
        <Dropdown
          style={{ width: "100%", textAlign: "left" }}
          value={value}
          options={selectionValues}
          placeholder={String(value)}
          onChange={e => onSelect(e)}
          required
        />
      );
    }
    return (
      <div className="p-inputtext p-d-flex p-jc-between" style={{ padding: "0" }}>
        <InputNumber
          value={value}
          onChange={e => handleChangeValue(e.value)}
          className="w-full"
          locale="lt"
          onFocus={e => e.target.select()}
          suffix={unit && unit.replaceAll(" ", "") ? ` ${unit}` : ""}
        />
      </div>
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{
        border: "none",
        whiteSpace: "nowrap",
        backgroundColor: "transparent",
        color: "inherit",
      }}
    >
      {`${formatNumber ? new Intl.NumberFormat("lt-LT").format(value) : value} ${unit}`}
    </div>
  );
}
